var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(_vm.getWidgetName(_vm.element),{tag:"component",attrs:{"element":_vm.element,"number":_vm.number,"zIndex":_vm.zIndex,"disabled":_vm.disabled},on:{"change":_vm.calcScore,"changeVideo":_vm.changeVideo}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }